import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import React from "react";
import {color, radius} from "common/tokens";

// A placeholder that holds the shape of something still on its way, so a page
// arrives in one piece instead of assembling itself in front of the reader.
// Sizes come from the call site — a skeleton should match what it stands in for.
const useStyles = makeStyles({
  block: {
    display: 'block',
    flexShrink: 0,
    borderRadius: radius.CONTROL,
    background: `linear-gradient(90deg, ${color.SURFACE_MUTED} 0%, ${color.DIVIDER} 50%, ${color.SURFACE_MUTED} 100%)`,
    backgroundSize: '200% 100%',
    animation: '$shimmer 1.3s ease-in-out infinite',
  },
  '@keyframes shimmer': {
    '0%': {backgroundPosition: '100% 0'},
    '100%': {backgroundPosition: '-100% 0'},
  },
  circle: {
    borderRadius: '50%',
  },
});

const Skeleton = ({width = '100%', height = 16, circle = false, className}) => {
  const classes = useStyles();

  return (
    <span
      className={classNames(classes.block, circle && classes.circle, className)}
      style={{width, height}}
      aria-hidden={true}
    />
  );
};

export default Skeleton;
